var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"ag-grid-cell-chip",attrs:{"pill":"","color":_vm.chipColor(_vm.params.value)}},[_c('span',[_vm._v(_vm._s(_vm.params.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }